import React, { useEffect, useState } from 'react';
import './Custlistprint.css';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { RssFeed } from '@material-ui/icons';
import { json } from 'react-router-dom';

Font.register({
  family: 'Lato-Italic',
  src: LatoItalicFont,
});

const Custlistprint = (props) => {
  const [customerData, setCustomerData] = useState({});
  const [literTotal, setLiterTotal] = useState(0);
  const [amtTotal, setAmtTotal] = useState(0);
  const [DataSource, setDataSource] = useState([]);
  const [input, setInput] = useState({
    kno: "", sr: "", cname: "", type: "", mobno: "", address: "", pass: "Auto", accno: "",
    obal: "", othev: "", mhvah: "", gayvah: "", mhthev: "", gaythev: "", kapatbill: "",
    hptabill: "", ikapatliter: "", ikapatbill: ""
  });
  let totals = {};

  useEffect(() => {
    const saved = localStorage.getItem("custlist_print") || localStorage.getItem("custlist");
    const parsed = saved ? JSON.parse(saved) : [];
    setDataSource(Array.isArray(parsed) ? parsed : []);
  }, []);

  if (Array.isArray(customerData) && customerData.length > 0) {
    totals = {
      ttthev: customerData.reduce((total, rowData) =>
        total + (rowData.tthev && rowData.tthev != null ? parseFloat(rowData.tthev) : 0)
        , 0),
    };
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const mode = localStorage.getItem("print_mode") || "default";

  // ✅ IMPORTANT: filter '-' names BEFORE pagination, otherwise pages will become uneven
  const filteredData = mode === "bank"
    ? (DataSource || []).filter(r => {
      const n = (r?.cname ?? "").toString().trim();
      return n !== "" && n !== "-" && n !== "0";
    })
    : (DataSource || []);

  // ✅ as you asked: 35 for bank mode
  const rowsPerPage = mode === "bank"
    ? 35
    : (localStorage.getItem("showall") === "Yes" ? 10 : 17);

  return (
    <PDFViewer className="pdf">
      <Document>
        {filteredData.length > 0 &&
          Array.from(
            { length: Math.ceil(filteredData.length / rowsPerPage) },
            (_, pageIndex) => {
              const start = pageIndex * rowsPerPage;
              const end = start + rowsPerPage;
              const pageRows = filteredData.slice(start, end);

              const isLandscape = localStorage.getItem("showall") === "Yes";
              const orientation = mode === "bank" ? "portrait" : (isLandscape ? "landscape" : "portrait");

              return (
                <Page
                  key={pageIndex}
                  size="A4"
                  orientation={orientation}
                  style={styles.page}
                >
                  {/* Header */}
                  <Text style={styles.latoText}>
                    {localStorage.getItem("kendra")}
                  </Text>

                  <Text style={styles.latoText}>
                    {mode === "bank"
                      ? ("सभासद बँक यादी (" + (localStorage.getItem("class") || "-") + ")")
                      : ("सभासद यादी (" + (localStorage.getItem("class") || "-") + ")")
                    }
                  </Text>

                  {/* Table */}
                  <View style={styles.table}>
                    {mode === "bank" ? (
                      <>
                        {/* ✅ BANK Table Header (NO IFSC) */}
                        <View style={styles.tableRowBankHeader}>
                          <Text style={styles.bankHeaderKno}>{"खाते"}</Text>
                          <Text style={styles.bankHeaderName}>{"नाव"}</Text>
                          <Text style={styles.bankHeaderBank}>{"बँक नाव"}</Text>
                          <Text style={styles.bankHeaderBranch}>{"शाखा"}</Text>
                          <Text style={styles.bankHeaderAcc}>{"खाते क्रमांक"}</Text>
                        </View>

                        {/* ✅ BANK Rows (compact, wrap disabled so React-PDF doesn't split inside page) */}
                        {pageRows.map((rowData, idx) => (
                          <View key={`${pageIndex}-${start + idx}`} style={styles.tableRowBank}>
                            <Text style={styles.bankCellKno} wrap={false}>
                              {rowData.kno != null ? String(rowData.kno) : "-"}
                            </Text>

                            <Text style={styles.bankCellName} wrap={false}>
                              {rowData.cname != null ? String(rowData.cname) : "-"}
                            </Text>

                            <Text style={styles.bankCellBank} wrap={false}>
                              {rowData.bankname != null ? String(rowData.bankname) : "-"}
                            </Text>

                            <Text style={styles.bankCellBranch} wrap={false}>
                              {rowData.branch != null ? String(rowData.branch) : "-"}
                            </Text>

                            <Text style={styles.bankCellAcc} wrap={false}>
                              {rowData.accno != null ? String(rowData.accno) : "-"}
                            </Text>
                          </View>
                        ))}
                      </>
                    ) : (
                      <>
                        {/* DEFAULT (YOUR EXISTING) Table Header */}
                        <View style={styles.tableRow}>
                          <Text style={styles.tableHeader}>{"खाते क्रमांक"}</Text>
                          <Text style={styles.tableHeader}>{"नाव"}</Text>
                          <Text style={styles.tableHeaderlast}>{"सुरू.बाकी"}</Text>
                          <Text style={styles.tableHeaderlast}>{"सुरू.खाद्य"}</Text>
                          <Text style={styles.tableHeaderlast}>{"सुरू.ठेव"}</Text>
                          <Text style={isLandscape ? styles.tableHeaderlast : styles.tableHeaderlasthide}>
                            {"सुरू.ठेव 1"}
                          </Text>
                          <Text style={isLandscape ? styles.tableHeaderlast : styles.tableHeaderlasthide}>
                            {"सुरू.ठेव 2"}
                          </Text>
                          <Text style={isLandscape ? styles.tableHeaderlast : styles.tableHeaderlasthide}>
                            {"सुरू.ठेव 3"}
                          </Text>
                          <Text style={isLandscape ? styles.tableHeaderlast : styles.tableHeaderlasthide}>
                            {"सुरू.रतीब"}
                          </Text>
                          <Text style={isLandscape ? styles.tableHeaderlast : styles.tableHeaderlasthide}>
                            {"सुरू.कर्ज"}
                          </Text>
                          <Text style={styles.tableHeaderlast}>{"पासवर्ड"}</Text>
                        </View>

                        {/* DEFAULT Rows (unchanged) */}
                        {pageRows.map((rowData, idx) => (
                          <>
                            <View key={"top_" + idx} style={styles.tableRow}>
                              <Text style={styles.tableCellleft}>
                                {start + idx + 1}   {rowData.cname}
                              </Text>
                            </View>

                            <View key={"row_" + idx} style={styles.tableRownotop}>
                              <Text style={styles.tableCellnoright2}></Text>
                              <Text style={styles.tableCellnoright}></Text>

                              <Text style={styles.tableCell}>
                                {rowData.obal != null ? parseFloat(rowData.obal) : 0}
                              </Text>

                              <Text style={styles.tableCell}>
                                {rowData.okhadya != null ? parseFloat(rowData.okhadya) : 0}
                              </Text>

                              <Text style={styles.tableCell}>
                                {rowData.othev != null ? parseFloat(rowData.othev) : 0}
                              </Text>

                              <Text style={isLandscape ? styles.tableCell : styles.tableCellhide}>
                                {rowData.othev1 != null ? parseFloat(rowData.othev1) : 0}
                              </Text>

                              <Text style={isLandscape ? styles.tableCell : styles.tableCellhide}>
                                {rowData.othev2 != null ? parseFloat(rowData.othev2) : 0}
                              </Text>

                              <Text style={isLandscape ? styles.tableCell : styles.tableCellhide}>
                                {rowData.othev3 != null ? parseFloat(rowData.othev3) : 0}
                              </Text>

                              <Text style={isLandscape ? styles.tableCell : styles.tableCellhide}>
                                {rowData.oratib != null ? parseFloat(rowData.oratib) : 0}
                              </Text>

                              <Text style={isLandscape ? styles.tableCell : styles.tableCellhide}>
                                {rowData.okarj != null ? parseFloat(rowData.okarj) : 0}
                              </Text>

                              <Text style={styles.tableCell}>
                                {rowData.pass != null ? rowData.pass : "---"}
                              </Text>
                            </View>
                          </>
                        ))}
                      </>
                    )}
                  </View>
                </Page>
              );
            }
          )}
      </Document>
    </PDFViewer>
  );
};

const styles = StyleSheet.create({
   page: {
    paddingTop: 30,
    paddingLeft: 20,   // ✅ add
    paddingRight: 20,  // ✅ add
    flexDirection: 'column',
  },

   table: {
    display: 'table',
    width: '100%',     // ✅ change from 97% to 100% (because page already has padding)
    marginTop: 2,
  },


  // ---------------- DEFAULT (your existing styles) ----------------
  tableRow: {
    flexDirection: 'row',
    marginTop: 5
  },
  tableRownotop: {
    flexDirection: 'row',
  },

  tableHeader: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    padding: 2,
    flex: 0.5,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
  },
  tableHeaderlast: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'solid',
    borderColor: 'lightblack',
    padding: 2,
    flex: 0.5,
    textAlign: 'center',
    fontSize: 9,
  },
  tableHeaderlasthide: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'solid',
    borderColor: 'lightblack',
    padding: 2,
    flex: 0.5,
    display: 'none',
    textAlign: 'center',
    fontSize: 9,
  },

  tableCellnoright: {
    borderTopWidth: 0,
    borderBottomWidth: 0.5,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    padding: 0.5,
    borderColor: 'lightblack',
    flex: 1,
    fontSize: 10,
    fontFamily: 'Lato-Italic',
    width: 2,
    textAlign: 'center',
  },
  tableCellnoright2: {
    borderTopWidth: 0,
    borderBottomWidth: 0.5,
    borderLeftWidth: 0.5,
    borderRightWidth: 0,
    padding: 0.5,
    borderColor: 'lightblack',
    flex: 1,
    fontSize: 10,
    fontFamily: 'Lato-Italic',
    width: 2,
    textAlign: 'center',
  },

  tableCell: {
    border: '0.5px solid lightblack',
    padding: 0.5,
    flex: 1,
    fontSize: 10,
    fontFamily: 'Lato-Italic',
    width: 2,
    textAlign: 'center',
  },
  tableCellhide: {
    border: '0.5px solid lightgray',
    padding: 0.5,
    flex: 1,
    fontSize: 10,
    fontFamily: 'Lato-Italic',
    width: 2,
    display: 'none',
    textAlign: 'center',
  },

  tableCellleft: {
    borderTopWidth: 0.5,
    borderBottomWidth: 0,
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
    borderColor: 'lightblack',
    padding: 1,
    flex: 1,
    fontSize: 10,
    fontFamily: 'Lato-Italic',
    width: 2,
    paddingLeft: 5,
    textAlign: 'left',
  },

  latoText: {
    fontFamily: 'Lato-Italic',
    fontSize: 14,
    marginBottom: 1,
    textAlign: 'center',
    width: '100vw',
    fontWeight: 'bold',
  },

  // ---------------- ✅ BANK (compact styles to prevent auto page split) ----------------
  tableRowBankHeader: {
    flexDirection: 'row',
    marginTop: 6,
  },

  bankHeaderKno: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    padding: 2,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
    flex: 0.6,
  },
  bankHeaderName: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    padding: 2,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
    flex: 1.3,
  },
  bankHeaderBank: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    padding: 2,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
    flex: 1.8,
  },
  bankHeaderBranch: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    padding: 2,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
    flex: 1.0,
  },
  bankHeaderAcc: {
    fontFamily: 'Lato-Italic',
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    padding: 2,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
    flex: 1.3,
  },

  tableRowBank: {
    flexDirection: 'row',
    marginTop: 0,      // ✅ compact
  },

  bankCellKno: {
    borderWidth: 0.5,
    borderColor: 'lightblack',
    padding: 1,        // ✅ compact
    fontSize: 8,       // ✅ compact
    fontFamily: 'Lato-Italic',
    textAlign: 'center',
    flex: 0.6,
  },
  bankCellName: {
    borderWidth: 0.5,
    borderColor: 'lightblack',
    padding: 1,
    fontSize: 8,
    fontFamily: 'Lato-Italic',
    textAlign: 'left',
    paddingLeft: 4,
    flex: 1.3,
  },
  bankCellBank: {
    borderWidth: 0.5,
    borderColor: 'lightblack',
    padding: 1,
    fontSize: 8,
    fontFamily: 'Lato-Italic',
    textAlign: 'left',
    paddingLeft: 4,
    flex: 1.8,
  },
  bankCellBranch: {
    borderWidth: 0.5,
    borderColor: 'lightblack',
    padding: 1,
    fontSize: 8,
    fontFamily: 'Lato-Italic',
    textAlign: 'left',
    paddingLeft: 4,
    flex: 1.0,
  },
  bankCellAcc: {
    borderWidth: 0.5,
    borderColor: 'lightblack',
    padding: 1,
    fontSize: 8,
    fontFamily: 'Lato-Italic',
    textAlign: 'center',
    flex: 1.3,
  },
});

export default Custlistprint;
